import Handsontable from 'handsontable'
import { createRoot } from 'react-dom/client'
import { TextEdit } from './components/link.jsx'

export class LinkEditor extends Handsontable.editors.TextEditor {
  constructor(props) {
    super(props)
    this.listenerFunction = function (ev) {
      const prevent = function () {
        ev.stopPropagation()
        ev.preventDefault()
        ev.returnValue = false
        return false
      }
      return prevent()
    }

    this.localdata = ''
  }

  prepare() {
    super.prepare(...arguments)
  }

  beginEditing(newInitialValue, event) {
    super.beginEditing(newInitialValue, event)
    this.open()
  }

  open() {
    this.hot.unlisten()
    this.onBeforeKeyDown = function (event) {
      switch (event.keyCode) {
        case Handsontable.helper.keyCode?.ARROW_UP:
          event.stopImmediatePropagation() // prevent EditorManager from processing this event
          event.preventDefault() // prevent browser from scrolling the page up
          break

        case Handsontable.helper.keyCode?.ARROW_DOWN:
          event.stopImmediatePropagation() // prevent EditorManager from processing this event
          event.preventDefault() // prevent browser from scrolling the page up
          break
      }
    }

    this.instance.addHook('beforeKeyDown', this.onBeforeKeyDown)

    this.parent = document.getElementById('reactTextEdit')
    if (!this.parent) {
      this.TEXTAREA_REACT = document.createElement('div')
      this.TEXTAREA_REACT.setAttribute('id', 'reactTextEdit')
      this.TEXTAREA_PARENT.appendChild(this.TEXTAREA_REACT)
      this.TEXTAREA_PARENT.className = `${this.TEXTAREA_PARENT.className} react`
      this.parent = this.TEXTAREA_REACT
    }

    const self = this
    this.handleClose = function (nextLine) {
      self.finishEditing()
      self.close()
      self.TD?.focus()
      if (nextLine) {
        if (self.col + 1 == self.instance.countCols()) {
          nextLine === 'TAB'
            ? self.instance.selectCell(self.row + 1, 0)
            : self.instance.selectCell(self.row + 1, self.col)
        } else {
          nextLine === 'TAB'
            ? self.instance.selectCell(self.row, self.col + 1)
            : self.instance.selectCell(self.row + 1, self.col)
        }
      }
    }

    this.updateData = function (data) {
      self.localdata = data
    }

    this.textareaStyle = this.TEXTAREA.style
    this.textareaStyle.width = 0
    this.textareaStyle.height = 0
    this.textareaStyle.minWidth = 0
    this.textareaStyle.maxWidth = 0

    this.textareaReactStyle = this.TEXTAREA_REACT.style
    this.textareaReactStyle.top = 2
    this.textareaReactStyle.position = 'absolute'
    this.textareaReactStyle.width = '100%'
    this.textareaReactStyle.height = `${this.TD.getClientRects()[0]?.height}px`

    this.TEXTAREA_PARENT.style.width = `${this.TD.getClientRects()[0]?.width}px`

    // lookup the nested options for the list directly from the ListDataManager
    const templateField = this.cellProperties
    const governanceOwner =
      templateField.field.segment_type === 'variable' ? templateField : templateField.field

    this.localdata = this.originalValue

    if (!this.root) {
      this.root = createRoot(this.parent)
    }
    console.log('LINK EDITOR')
    this.root.render(
      <TextEdit
        data={this.originalValue}
        cellProperties={this.cellProperties}
        updateData={this.updateData}
        governance={governanceOwner}
        templateField={templateField}
        row={this.row}
        close={this.handleClose}
        parent={this.parent}
      />,
    )
    document
      .querySelectorAll('#reactTextEdit')[0]
      .addEventListener('wheel', this.listenerFunction, { passive: true })

    this.refreshDimensions() // need it instantly, to prevent https://github.com/handsontable/handsontable/issues/348
    this.showEditableElement()
    super.open()
  }

  getValue() {
    return this.localdata
  }

  setValue(value) {
    this.TEXTAREA.value = value
  }

  focus() {}

  finishEditing(restoreOriginalValue, ctrlDown, callback) {
    document
      .querySelectorAll('#reactTextEdit')[0]
      ?.removeEventListener('wheel', this.listenerFunction)
    super.finishEditing(restoreOriginalValue, ctrlDown, callback)

    if (this.root) {
      this.root.unmount()
      this.root = null
    }

    if (this.parent && this.parent.parentNode) {
      this.parent.parentNode.removeChild(this.parent)
      this.parent = null
    }
  }

  close(...args) {
    this.localdata = ''
    this.instance.removeHook('beforeKeyDown', this.onBeforeKeyDown)

    if (!this.instance.rootElement) {
      return
    }

    super.close(...args)
  }

  createElements() {
    super.createElements()
    this.TEXTAREA_REACT = document.createElement('div')
    this.TEXTAREA_REACT.setAttribute('id', 'reactTextEdit')
    this.TEXTAREA_PARENT.appendChild(this.TEXTAREA_REACT)
    this.TEXTAREA_PARENT.className = `${this.TEXTAREA_PARENT.className} react`
  }
}
